<template>
  <div class="ch-container">
    <div v-if="isTeacher" class="flex justify-between flex-wrap items-center">
      <vs-select v-if="hasManyGroups" v-model="selectedGroup" class="mb-base vs-input-shadow-drop vs-select-no-border d-theme-input-dark-bg w-48">
        <vs-select-item value="0" text="كل المجموعات" />
        <vs-select-item v-for="group in getCourseDetails.groups" :key="group.group" :value="group.group" :text="group.group" />
      </vs-select>
      <div v-else></div>
      <vs-button class="mb-base" @click="openAssignmentForm()" color="success" icon-pack="feather" icon="icon-plus" icon-after>واجب جديد</vs-button>
    </div>
    <template v-if="assignments.length > 0">
      <div id="assignments" class="vx-row vs-con-loading__container">
        <div v-for="assignment in assignmentsSort" :key="assignment.id" class="vx-col w-full mb-base">
          <assignment-item :assignment="assignment" @edit="openAssignmentForm" @delete="deleteAssignment"/>
        </div>
      </div>
    </template>
    <div v-else class="mt-8 text-center">
      <img class="w-full mb-base max-w-xs" src="@/assets/images/svg/no-data.svg" alt="quizzes.svg">
      <h2 class="text-left text-primary mb-2">لا يوجد واجبات</h2>
      <h5 class="text-left">
        <span v-if="isTeacher">يمكنك إضافة واجب جديد عن طريق الضغط علي زر واجب جديد </span>
        <span v-if="isStudent">قم بالتحقق لاحقاً عندما يقوم الاستاذ بإضافة واجب</span>
      </h5>
    </div>
    <assignment-form @submit="saveAssignment" :data="assignmentData" :active.sync="isAssignmentFormActive"/>
  </div>
</template>

<script>
    import assignmentForm from './AssignmentForm.vue'
    import assignmentsAPI from '@/api/assignmentsAPI'
    import AssignmentItem from '@/views/course/assignments/assignmentItem'

    export default {
        name: "Assignments.vue",
        components: {
            AssignmentItem,
            assignmentForm
        },
        data() {
            return {
                course_id: this.$route.params.course_id,
                selectedGroup: 0,
                assignments: [],
                assignmentData: {},
                assignmentEditIndex: null,
                isAssignmentFormActive: false,
            }
        },
        computed: {
            assignmentsSort() {
                let assignments = this.assignments.filter((assignment) => {
                    return assignment.groups ? assignment.groups.includes(this.selectedGroup) || this.selectedGroup == 0 : true
                })
                return assignments.sort((first, second) => {
                    return new Date(second.deadline) - new Date(first.deadline)
                })
            },
        },
        methods: {
            openAssignmentForm(assignment = {}){
                Object.assign(this.assignmentData = {}, assignment)
                this.assignmentEditIndex = this.assignments.indexOf(assignment)
                this.isAssignmentFormActive = true
            },
            saveAssignment(assignment){
                this.assignmentEditIndex !== -1 ? this.$set(this.assignments, this.assignmentEditIndex, assignment) : this.assignments.push(assignment)
            },
            deleteAssignment(assignment){
              const message = `هل تريد حذف هذا الواجب "${assignment.title}"؟`
              this.$confirmAlert(null, message, () => {
                this.$startLoading()
                let index = this.assignments.indexOf(assignment)
                assignmentsAPI.delete(assignment.id)
                        .then((response) => {
                          this.$delete(this.assignments, index)
                          this.$notifySuccess(response.successMessage)
                        })
                        .catch(error => this.$notifyError(error.statusMessage))
                        .finally(() => this.$closeLoading())
              })
            },
        },
        beforeRouteEnter(to, from, next){
            assignmentsAPI.setCourseId(to.params.course_id)
            assignmentsAPI.getAll().then(({data}) => {
                next(vm => vm.assignments = Object.values(data.assignments))
            })
            .catch(error => {if(error.status === 404) next('/not-found-404')})
        },
    }
</script>
